import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@fontsource/ibm-plex-sans/400.css';
import '@fontsource/ibm-plex-sans/600.css';
import '@fontsource/ibm-plex-mono/400.css';
import '@fontsource/ibm-plex-mono/500.css';
import '@fontsource-variable/archivo';
import './styles/app.css';
import { App } from './App.tsx';
import { useStudio } from './state/store.ts';
import { useEdit } from './state/edit.ts';

// Nur in der Entwicklung: Zugriff für automatische Browser-Tests
if (import.meta.env.DEV) void Promise.all([import('./audio/engine.ts'), import('@srs/shared'), import('./audio/elastic.ts'), import('./audio/segments.ts'), import('./bridge/client.ts'), import('./audio/vocalscan.ts'), import('./edit/vocal.ts'), import('./edit/pitch.ts'), import('./audio/bridgefx.ts'), import('./audio/fxstate.ts')]).then(([m, sh, el, sg, br, vs, vo, pi, bf, fs]) => Object.assign(window, { __pitch: pi, __bfx: { ...bf, ...fs }, __studio: useStudio, __edit: useEdit, __engine: m.engine, __tempo: sh, __elastic: el, __segments: sg, __bridge: br.bridge, __vocal: { ...vs, ...vo } }));

createRoot(document.getElementById('root')!).render(<StrictMode><App /></StrictMode>);
